/**
 * Pulse — the universal Health-Wall model (docs/lifecycle-spine/PRD.md §1).
 *
 * A bar is not hand-drawn — it is one `TouchpointDef`, a pure declaration the
 * engine evaluates per subject. Adding a bar = adding one object to a group's
 * `touchpoints[]`. This file is the authoring contract; it is PURE (no DB, no
 * React) so it rides in the `@excellent/core` index barrel. Provider
 * IMPLEMENTATIONS (which touch the DB via `loadSources`) live under
 * `providers/` and surface through `@excellent/core/server`.
 */
/** Verb per kind (the primary action on the bar). Mirrors `PRIMARY_VERB` in the
 *  `_zoom.tsx` prototype. */
export const PRIMARY_VERB = {
    automation: "Run now",
    stage: "Advance",
    channel: "Open",
    signal: "Open",
    metric: "Set alert",
    queue: "Open queue",
    task: "Complete",
    integration: "Reconnect",
};
/** Icon key per kind (resolved by `<Icon>`, never raw lucide). Mirrors
 *  `KIND_ICON` in `_grain.tsx`. */
export const KIND_ICON = {
    automation: "zap",
    stage: "git-commit-horizontal",
    channel: "radio",
    signal: "activity",
    metric: "gauge",
    queue: "inbox",
    task: "square-check",
    integration: "plug",
};
